'use strict';
var React = require('react');
var reactDom = require('react-dom');
var ReactRedux = require('react-redux');
var Store = require('../../redux/store.js');

if (window.APP === 'item-search') {
    var SearchComponent = require('../../views/search/index').SearchComponentHome;
    const store = Store.createSearchStore(window.REDUX_DATA);
    const app = document.getElementById("root");

    const renderMethod = module.hot ? reactDom.render : reactDom.hydrate;
    renderMethod(
        <ReactRedux.Provider suppressHydrationWarning={true} store={store}>
            <SearchComponent />
        </ReactRedux.Provider>,
        app
    );
}